import PropTypes from "prop-types";
import React, { Component } from "react";

//Simple bar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { Link, withRouter } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";
import { getListByPermissions } from "../../helpers/utils";
import { authProtectedRoutes } from "../../routes";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.refDiv = React.createRef();
  }

  componentDidMount() {
    this.initMenu();
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, ss) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    const pathname = this.props.location.pathname.split("/")[1];
    for (let i = 0; i < items.length; ++i) {
      const item_path = items[i].pathname.split("/")[1];
      if (
        pathname === item_path ||
        (item_path === "clients" && pathname === "offers")
      ) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  // componentDidUpdate() {}

  scrollElement = item => {
    setTimeout(() => {
      if (this.refDiv.current !== null) {
        if (item) {
          const currentPosition = item.offsetTop;
          if (currentPosition > window.innerHeight) {
            if (this.refDiv.current)
              this.refDiv.current.getScrollElement().scrollTop =
                currentPosition - 300;
          }
        }
      }
    }, 300);
  };

  activateParentDropdown = item => {
    item.classList.add("active");
    const parent = item.parentElement;

    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      this.scrollElement(item);
      return false;
    }
    this.scrollElement(item);
    return false;
  };

  renderOverviewName = () => {
    const { permissions } = this.props;
    if (
      permissions["is_head_of_mediabuyer"] ||
      permissions["is_head_of_accountmanager"] ||
      permissions["is_admin"]
    ) {
      return "Top Management";
    }

    if (permissions["is_accountmanager"] || permissions["is_mediabuyer"]) {
      return "Individual Report";
    }

    return "Top Management";
  };

  render() {
    const allRoutes = getListByPermissions(
      authProtectedRoutes,
      this.props.permissions
    ).map(i => i.path);
    // console.log('All routes:', allRoutes);
    // console.log(this.props.permissions);
    const data = [
      {
        title: this.props.t("Dashboards"),
        href: "/#",
        icon: <i className="bx bx-home-circle" />,
        submenu: [
          {
            title: this.renderOverviewName(),
            href: "/overview",
          },
          { title: "Quality Report", href: "/quality-report" }, // quality-non-cahort-report
          { title: "Quality Rent Report", href: "/quality-rent-report" },
          { title: "Quality Cohort Report", href: "/quality-cohort-report" },
          { title: "Users Actions", href: "/users-actions" },
          { title: "Health", href: "/health" },
          // { title: "Top Management Report", href: "/top-management-report" },
          // { title: "Payment & Cost Inspection report", href: "/payment-cost-inspection-reports" },
          // { title: "Managers Report", href: "/managers-report" },
          // { title: "Finance Report", href: "/finance-report" },
          // {
          //   title: "Non cohort quality report",
          //   href: "/non-cahort-quality-report",
          // },
          // {
          //   title: "Detailed by offers report",
          //   href: "/detailed-by-offers-report",
          // },
          // {
          //   title: "Detailed non cohort report",
          //   href: "/detailed-non-cahort-report",
          // },
        ],
      },
      {
        title: "Campaigns",
        href: "/#",
        icon: <i className="bx bx-chevron-left-square" />,
        submenu: [
          // { title: "List", href: "/campaigns" },
          // { title: "Offer types", href: "/offer-types" },
          { title: "Sources", href: "/sources" },
          // { title: "Direction types", href: "/direction-types" },
          // { title: "Formats", href: "/formats" },
          // { title: "Statuses", href: "/statuses" },
          { title: "Media buyers", href: "/media-buyers" },
          { title: "Advertising Accounts", href: "/advertising-accounts" },
          { title: "Cabinet Limits", href: "/cabinet-limits" },
          { title: "Cashbacks", href: "/cashbacks" },
          // { title: "Device types", href: "/device-types" },
          // { title: "Custom names", href: "/custom-names" },
          // { title: "Create TT campaign", href: "/campaigns_tt/add" },
          // { title: "*Validator", href: "/campaign-validator" },
        ],
      },
      /*{
                          title: "Reporting",
                          href: "/#",
                          icon: <i className="mdi mdi-google-analytics" />,
                          submenu: [
                            // { title: "Managers report", href: "/managers-report" },
                            // { title: "Finance report", href: "/finance-report" },
                            { title: "Quality non cahort report", href: "/quality-non-cahort-report" },
                            { title: "Top management reports", href: "/top-management-reports" },
                            { title: "Cohort Reports", href: "/cohort-reports" },
                            // {
                            //   title: "Non cohort quality report",
                            //   href: "/non-cahort-quality-report",
                            // },
                            // {
                            //   title: "Detailed by offers report",
                            //   href: "/detailed-by-offers-report",
                            // },
                            // {
                            //   title: "Detailed non cohort report",
                            //   href: "/detailed-non-cahort-report",
                            // },
                          ]
                        },*/
      // {
      //   title: 'Plans',
      //   href: "/plans",
      //   icon: <i className="bx bx-pencil" />
      // },
      // {
      //   title: "Integration",
      //   href: "/#",
      //   icon: <i className="mdi mdi-pinwheel-outline" />,
      //   submenu: [
      //     // { title: "VK Banners", href: "/banners_vk" },
      //     // { title: "VK Campaigns", href: "/campaigns_vk" },
      //     // { title: "VK Clients", href: "/clients_vk" },
      //     { title: "TikTok Advertisers", href: "/advertisers_tiktok" },
      //     // { title: "MyTarget Banners", href: "/banners_mytarget" },
      //     // { title: "MyTarget Campaigns", href: "/campaigns_mytarget" },
      //     // { title: "MyTarget Agencies", href: "/agencies_mytarget" }
      //   ]
      // },
      {
        title: "Clients",
        href: "/#",
        icon: <i className="mdi mdi-account-group-outline" />,
        submenu: [
          { title: "Clients", href: "/clients" },
          { title: "Payment formulas", href: "/payment-formulas" },
          { title: "Applications", href: "/applications" },
        ],
      },
      {
        title: "Accounting",
        href: "/#",
        icon: <i className="bx bx-receipt" />,
        submenu: [
          { title: "Invoices", href: "/invoices" },
          { title: "Invoice templates", href: "/invoice-templates" },
          { title: "Contractors", href: "/contractors" },
          { title: "Legal entity", href: "/legal-entity" },
          { title: "Service Providers", href: "/service-providers" },
          { title: "Reconciliations", href: "/reconciliations" },
          { title: "Clients", href: "/#" },
        ],
      },
      {
        title: "Project Manager Tool",
        href: "/#",
        icon: <i className="bx bx-task" />,
        submenu: [{ title: "Plans", href: "/project-manager-plans" }],
      },
      {
        title: "Media buying tool",
        href: "/#",
        icon: <i className="bx bx-pencil" />,
        submenu: [
          //{ title: "Media buyer budgets", href: "/media-buyer-budget" },
          { title: "Plans", href: "/plans" },
        ],
      },
      {
        title: "Upload data",
        href: "/#",
        icon: <i className="mdi mdi-file-upload-outline" />,
        submenu: [
          { title: "Upload widget", href: "/upload-widget" },
          { title: "Upload history", href: "/upload-history" },
        ],
      },
      {
        title: "Settings",
        href: "/#",
        icon: <i className="bx bx-wrench" />,
        submenu: [
          { title: "Users", href: "/users" },
          { title: "Positions", href: "/positions" },
          { title: "Bonuses", href: "/salary-bonuses" },
          { title: "ID Generator", href: "/id-generator" },
        ],
      },
    ];

    // console.log(this.props.permissions);

    // console.log(this.props);

    return (
      <React.Fragment>
        <SimpleBar className="h-100" ref={this.refDiv}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              {data.map(({ title, href, icon, submenu }, index) => {
                const some = submenu
                  ? submenu?.filter(i => allRoutes.includes(i.href))
                  : allRoutes.includes(href);
                // console.log(some);
                if (some === true || (Array.isArray(some) && some.length > 0))
                  return (
                    <li key={title}>
                      <Link
                        to={href}
                        className={submenu?.length > 0 ? "has-arrow" : ""}
                      >
                        {icon}
                        {/*<span>{this.props.t("Ecommerce")}</span>*/}
                        <span>{title}</span>
                      </Link>
                      {submenu?.length > 0 && (
                        <ul className="sub-menu" aria-expanded="false">
                          {some?.map(i => (
                            <li key={i.title + i.href}>
                              <Link to={i.href}>
                                {/*{this.props.t("Products")}*/}
                                {/*List*/}
                                {i.title}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  );
              })}
            </ul>
          </div>
        </SimpleBar>
      </React.Fragment>
    );
  }
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
  type: PropTypes.string,
  permissions: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
